<template>
  <div class="indexIMG">
    <div>
      <p>成为世界领先的科技企业</p>
      <div>Become a world-leading</div>
      <div>technology company</div>
      <div class="box1-text">Become a world-leading technology company</div>
    </div>
  </div>
  <div class="box1" id="introduce">
    <div>公司简介</div>
    <div>Company Introduction</div>
    <div class="center">
      <div class="right">
        <img class="slide-in-fwd-tr" src="../img/index/company.png" alt="" />
      </div>
      <div class="left slide-in-fwd-left">
        <div>
          浙江云端时代科技有限公司成立于2014年。是一家集电子商务基础性研究、ERP系统集成、网络销售、供应链管理等多元化业务于一体的外卖B2C电子商务企业。公司致力于打造跨境电商一站式服务平台,是跨境电子商务行业中拔萃的新生力量。从国内到国外,公司经历着高速而稳健的发展。
        </div>
        <div>
          <div>
            <span> 2000</span>万
            <div style="">已累计服务用户</div>
          </div>
          <div>
            <span> 10</span>个
            <div>业务覆盖国家</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="box1" id="architecture">
    <div>业务框架</div>
    <div>Bysiness Architecture</div>

    <div class="center">
      <div class="box">
        <img src="../img/index/icon1.png" alt="" />
        <p>综合管理中心</p>
      </div>
      <div class="box">
        <img src="../img/index/icon2.png" alt="" />
        <p>产品中心</p>
      </div>
      <div class="box">
        <img src="../img/index/icon3.png" alt="" />
        <p>销售运营中心</p>
      </div>
      <div class="box">
        <img src="../img/index/icon4.png" alt="" />
        <p>设计中心</p>
      </div>
      <div class="box">
        <img src="../img/index/icon5.png" alt="" />
        <p>物流中心</p>
      </div>
      <div class="box">
        <img src="../img/index/icon6.png" alt="" />
        <p>IT研发中心</p>
      </div>
      <div class="box">
        <img src="../img/index/icon7.png" alt="" />
        <p>人力行政中心</p>
      </div>
      <div class="box">
        <img src="../img/index/icon8.png" alt="" />
        <p>财务管理中心</p>
      </div>
    </div>
  </div>
  <div class="box1" id="design">
    <div>创新设计</div>
    <div>Innovative Design</div>
    <div class="center">
      <div class="box1">
        <img class="slide-in-fwd-tr" src="../img/index/design.png" alt="" />
      </div>
      <div class="box1" style="">
        <div>精湛工艺</div>
        <div>Superb Craftsmanship</div>
      </div>
      <div class="box1">
        <img class="slide-in-fwd-tr" src="../img/index/design1.png" alt="" />
      </div>
      <div class="box1">
        <div>高级定制</div>
        <div>Haute Couture</div>
      </div>
      <div class="box1">
        <img class="slide-in-fwd-tr" src="../img/index/design2.png" alt="" />
      </div>
      <div class="box1">
        <div>高端品牌</div>
        <div>Premium Brand</div>
      </div>
    </div>
  </div>
  <div class="box1" id="process">
    <div>发展历程</div>
    <div>Development Process</div>
    <div class="center">
      <div class="right">
        <div class="box1">
          <el-button
          id="appBnt"
          text
            :icon="ArrowLeftBold"
            circle
            @click="() => carouselRef.prev()"
          />
          <img class="slide-in-fwd-tr" :src="developmentleft.url" alt="" />

          <el-button
                 id="appBnt"
                 text
            :icon="ArrowRightBold"
            circle
            @click="() => carouselRef.next()"
          />
        </div>

        <div id="year">
          <span>{{ developmentleft.title }}</span
          ><span> 年</span>
        </div>
        <div id="content" v-for="item in developmentleft.text.split('/')">
          {{ item || "" }}
        </div>
      </div>
      <div class="left">
        <el-button
          :icon="ArrowUpBold"
          circle
          @click="() => carouselRef.prev()"
        />

        <el-carousel
          height="300px"
          direction="vertical"
          type="card"
          arrow="always"
          ref="carouselRef"
          indicator-position="none"
          @change="carouselChange"
          :autoplay="false"
        >
          <el-carousel-item v-for="(item, index) in carouselList" :key="index">
            <h1
              style=""
              text="2xl"
              justify="center"
              :class="{ textactive: item.textactive }"
            >
              {{ item.year }}
            </h1>
          </el-carousel-item>
        </el-carousel>

        <el-button
          :icon="ArrowDownBold"
          circle
          @click="() => carouselRef.next()"
        />
      </div>
    </div>
  </div>

  <div class="box1" id="location">
    <div class="title" style="">办公地点</div>
    <div style="">Office Location</div>
    <div class="center">
      <div class="left">
        <p id="countryTitle">{{ locationData.title }}</p>
        <div>地址：{{ locationData.address }}</div>
        <div>邮编：{{ locationData.postalCode }}</div>
      </div>
      <div class="right">
        <img :src="locationData.url" alt="" />
      </div>
    </div>
    <div class="center timeline">
      <div id="container">
        <div ref="centerRef" style=""></div>
      </div>
      <div id="country">
        <div class="box1 China">
          <div @click="goCountry(locationList[0])">
            <el-icon><Location /></el-icon>中国
          </div>
        </div>
        <div class="box1 USA" @click="goCountry(locationList[1])">
          <div @click="goCountry(locationList[1])">
            <el-icon><Location /></el-icon>美国
          </div>
        </div>
        <div class="box1 Japan" @click="goCountry(locationList[2])">
          <div @click="goCountry(locationList[2])">
            <el-icon><Location /></el-icon>日本
          </div>
        </div>
        <div class="box1 Germany" @click="goCountry(locationList[3])">
          <el-icon><Location /></el-icon>德国
        </div>
      </div>
    </div>
  </div>
  <div class="bottonImg">
    <img src="../img/index/product.png" alt="" />
  </div>
</template>
<script setup>
import { ArrowUpBold, ArrowDownBold ,ArrowRightBold,ArrowLeftBold} from "@element-plus/icons-vue";
import { Location, Picture, Upload } from "@element-plus/icons-vue";

import { ref, triggerRef } from "vue";
import { onMounted, onUnmounted } from "vue";

const centerRef = ref();
const carouselRef = ref();
// 根据屏幕的大小修改box3轮播图的大小
let lunboheight = ref("600px");
const developmentleft = ref({
  year: "2024",
  title: "2024",
  url: require("../img/index/carousel2024.png"),
  text: "孵化10+个知名品牌，业务覆盖全球100多/个国家和地区，服务用户1亿+",
  textactive: false,
});
const carouselList = ref([
  {
    year: "2024",
    title: "2024",
    url: require("../img/index/carousel2024.png"),
    text: "孵化10+个知名品牌，业务覆盖全球100多/个国家和地区，服务用户1亿+",
    textactive: false,
  },
  {
    year: "2023",
    title: "2020-2023",
    url: require("../img/index/carousel2023.png"),
    text: "完成海外仓的布局并搭建全球本土化平/台的建设品牌短阵的战略实施",
    textactive: false,
  },
  {
    year: "2018",
    title: "2018-2020",
    url: require("../img/index/carousel2018.png"),
    text: "在亚马逊平台体量进一步扩大，年销售额过亿,/同时开始布局全球多国的本士平台，全渠道的销售",
    textactive: false,
  },
  {
    year: "2016",
    title: "2016-2018",
    url: require("../img/index/carousel2016.png"),
    text: "建立开始搭建品牌矩阵,创立了云端体/系得第一个男装品牌",
    textactive: false,
  },
  {
    year: "2014",
    title: "2014",
    url: require("../img/index/carousel2014.png"),
    text: "浙江云端时代科技有限公司正式成立/",
    textactive: true,
  },
]);

const carouselChange = (x, y) => {
  developmentleft.value = carouselList.value[x];
  carouselList.value[x].textactive = true;
  carouselList.value[y].textactive = false;
};
const locationData = ref({
  num: "0",
  title: "杭州,中国",
  url: require("../img/index/location1.png"),
  address: "杭州市临平区CBC时代大厦",
  postalCode: 310000,
});
const locationList = ref([
  {
    num: 0,
    title: "杭州,中国",
    url: require("../img/index/location1.png"),
    address: "杭州市临平区CBC时代大厦",
    postalCode: 310000,
  },
  {
    num: 32,
    title: "AzUSA，美国",
    url: require("../img/index/location2.png"),
    address: "16009 Camino de la Cantera Irwindale CA",
    postalCode: 91702,
  },
  {
    num: 64,
    title: "大阪府，日本",
    url: require("../img/index/location3.png"),
    address: "大字二河原邊３１番地 千早赤阪村 南河内郡 大阪府",
    postalCode: 5850042,
  },
  {
    num: 96,
    title: "科隆，德国",
    url: require("../img/index/location4.png"),
    address: "Rheinische Allee 2 Köln ",
    postalCode: 50858,
  },
]);
const goCountry = (data) => {
  centerRef.value.style.left = data.num + "%";
  locationData.value = data;
};
screenwid();
function screenwid() {
  if (document.querySelector("html").offsetWidth <= 960) {
    lunboheight.value = "156px";
    triggerRef(lunboheight);
  }
}
</script>
<style lang="scss" scoped>
.textactive {
  color: #043d91 !important;
}
//box1的图片动画效果

.slide-in-fwd-tr {
  -webkit-animation: slide-in-fwd-tr 1.5s;
  animation: slide-in-fwd-tr 1.5s;
}

@-webkit-keyframes slide-in-fwd-tr {
  0% {
    -webkit-transform: translateZ(-1400px) translateY(-800px) translateX(1000px);
    transform: translateZ(-1400px) translateY(-800px) translateX(1000px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateZ(0) translateY(0) translateX(0);
    transform: translateZ(0) translateY(0) translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-fwd-tr {
  0% {
    -webkit-transform: translateZ(-1400px) translateY(-800px) translateX(1000px);
    transform: translateZ(-1400px) translateY(-800px) translateX(1000px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateZ(0) translateY(0) translateX(0);
    transform: translateZ(0) translateY(0) translateX(0);
    opacity: 1;
  }
}

// box1文字的动画效果

.slide-in-fwd-left {
  -webkit-animation: slide-in-fwd-left 1.5s;
  animation: slide-in-fwd-left 1.5s;
}

@-webkit-keyframes slide-in-fwd-left {
  0% {
    -webkit-transform: translateZ(-1400px) translateX(-1000px);
    transform: translateZ(-1400px) translateX(-1000px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateZ(0) translateX(0);
    transform: translateZ(0) translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-fwd-left {
  0% {
    -webkit-transform: translateZ(-1400px) translateX(-1000px);
    transform: translateZ(-1400px) translateX(-1000px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateZ(0) translateX(0);
    transform: translateZ(0) translateX(0);
    opacity: 1;
  }
}

@media screen and (min-width: 960px) {
  .indexIMG {
    background: url(../img/index/index.png);
    background-repeat: no-repeat;
    background-size: 100%;
    height: 740px;
    .box1-text {
      display: none;
    }
    > div {
      width: 1100px;
      margin: 0 auto;
      text-align: left;
      padding-top: 98px;
      p {
        margin: 0;
        color: #545555;
        font-size: 40px;
      }
      div:nth-child(2) {
        margin-top: 14px;
      }
      div:nth-child(3) {
        margin-top: 0px;
      }
      div {
        color: #545555;
        line-height: 30px;
        font-size: 28px;
      }
    }
  }

  .box1 {
    overflow: hidden;
    // height: 770px;

    .center {
      // height: 464px;
      padding: 40px 0px 40px;
      width: 1200px;
      margin: auto;
      display: flex;

      .left {
        margin-right: 160px;
        width: 646px;

        p {
          font-size: 28px;
          // padding-bottom: 30px;
          text-align: left;
          margin-bottom: 16px;
          color: #484747;
          font-weight: 500;
        }

        div {
          font-size: 20px;
          line-height: 40px;
          text-align: left;
          // text-indent: 36px;
          // letter-spacing: 2px;
          color: #484747;
          font-weight: 500;
        }
      }

      .right {
        img {
          width: 600px;
          height: auto;
        }
      }
    }
  }
  #introduce {
    > div:nth-child(1) {
      text-align: center;
      margin-top: 120px;
      font-size: 30px;
      font-weight: 500;
      color: #333333;
    }
    > div:nth-child(2) {
      text-align: center;
      color: #333333;
      margin-top: 6px;
    }
    .slide-in-fwd-left {
      margin-left: 30px;
      > div:nth-child(2) {
        display: flex;
        margin-top: 20px;
        div {
          span {
            font-size: 30px;
            color: #043d91;
            div {
              font-size: 12px;
            }
          }
        }
        > div:nth-child(2) {
          margin-left: 30px;
        }
      }
    }
  }
  #architecture {
    background-color: #f2f2f2;
    padding-bottom: 40px;
    > div:nth-child(1) {
      text-align: center;
      margin-top: 100px;
      font-size: 30px;
      font-weight: 500;
      color: #333333;
    }
    > div:nth-child(2) {
      text-align: center;
      color: #333333;
      margin-top: 6px;
    }
    > .center {
      display: flex;
      justify-content: space-between;
      .box {
        text-align: center;
      }
    }
  }
  #design {
    > div:nth-child(1) {
      text-align: center;
      margin-top: 100px;
      font-size: 30px;
      font-weight: 500;
      color: #333333;
    }
    > div:nth-child(2) {
      text-align: center;
      color: #333333;
      margin-top: 6px;
    }
    > .center {
      display: flex;
      flex-wrap: wrap;
      .box1 {
        width: 33%;
        background-color: #f2f2f2;
        // text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img {
          width: 100%;
          height: 100%;
        }
        div:nth-child(1) {
          font-size: 32px;
          font-weight: 500;
          // margin-top: 70px;
          color: #333333;
        }
        div:nth-child(2) {
          color: #818181;
          margin-top: 6px;
        }
      }
    }
  }
  #process {
    #appBnt{
      display: none;
    }
    > div:nth-child(1) {
      text-align: center;
      margin-top: 100px;
      font-size: 30px;
      font-weight: 500;
      color: #333333;
    }
    > div:nth-child(2) {
      text-align: center;
      color: #333333;
      margin-top: 6px;
    }
    .center {
      .right {
        color: #5c5c5c;
        text-align: left;
        #year {
          margin-top: 20px;
          margin-bottom: 10px;
          > span:nth-child(1) {
            font-size: 28px;
            font-weight: 500;
          }
          > span:nth-child(2) {
            font-weight: 700;
          }
        }
        #content {
          font-weight: 500;
          height: 24px;
        }
      }
      .left {
        margin-left: 230px;
        align-items: center;
        display: flex;
        align-items: center;
        flex-direction: column;
        h1 {
          font-size: 30px;
          font-weight: 700;
        }
      }
    }
  }
  #location {
    .left{
      margin-right: 85px;
    }
    .title {
      text-align: center;
      margin-top: 100px;
      font-size: 30px;
      font-weight: 500;
      color: #333333;
    }
    div:nth-child(2) {
      color: #333333;
      margin-top: 6px;
    }
    > .timeline {
      display: flex;
      flex-direction: column;
      #container {
        width: 1200px;
        background-color: #d5d5d5;
        position: absolute;
        div {
          width: 43px;
          border: 2px solid #053e91;
          position: relative;
          left: 0;
        }
      }
      #country {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        .China {
          width: 31%;
          div {
            width: 60px;
          }
        }
        .Japan {
          width: 32%;
          div {
            width: 60px;
          }
        }
        .USA {
          width: 30%;
          div {
            width: 60px;
          }
        }
        .Germany {
          width: 5%;
        }
      }
    }
  }
  .bottonImg {
    width: 100%;
    height: 960px;
    overflow: hidden;
    img {
      width: 110%;
    }
  }

  .el-carousel__item h1 {
    color: #e1e1e1;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
    text-align: center;
  }

  .el-carousel--vertical {
    width: 200px;
  }
  .USAlocationName {
    left: 30%;
  }
  .center .box1:hover {
    color: #053e91;
  }
}

@media screen and (max-width: 960px) {
  .bottonImg {
    height: 172px;
    overflow: hidden;
    margin-top: 20px;
    img {
      width: 100%;
    }
  }
  .indexIMG {
    background: url(../img/index/index.png);
    background-repeat: no-repeat;
    background-size: 100%;
    height: 150px;
    margin-top: 38px;
    > div {
      width: 320px;
      margin: 0 auto;
      text-align: left;
      padding-top: 6px;

      p {
        margin: 0;
        color: #545555;
        font-size: 12px;
        padding-top: 20px;
        margin-top: 18px;
      }
      > div:nth-child(2),
      > div:nth-child(3) {
        display: none;
      }

      > .box1-text {
        color: #545555;
        line-height: 16px;
        font-size: 12px;
        transform: scale(0.7); /* 缩放比例：10/12 */
        transform-origin: 0 0; /* 确保左上角对齐 */
        white-space: nowrap; /* 防止换行 */
        margin-top: 2px;
      }
    }
  }
  .box1 {
    overflow: hidden;
    // height: 770px;
    > div:nth-child(1) {
      text-align: center;
      margin-top: 20px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
    }
    > div:nth-child(2) {
      text-align: center;
      color: #333333;
      font-size: 12px;
      // background-color: pink;
      margin-top: 2px;
    }

    .center {
      // height: 464px;
      padding: 10px 0px 10px;
      width: 320px;
      margin: auto;
      // display: flex;

      .left {
        // margin-right: 160px;
        width: 330px;

        p {
          font-size: 28px;
          padding-bottom: 30px;
          text-align: left;
          margin-bottom: 18px;
          color: #484747;
          font-weight: 500;
        }

        div {
          font-size: 12px;
          line-height: 20px;
          text-align: left;
          // text-indent: 36px;
          // letter-spacing: 2px;
          color: #484747;
          font-weight: 500;
        }
      }

      .right {
        img {
          width: 320px;
          height: auto;
        }
      }
    }
  }
  #introduce {
    .slide-in-fwd-left {
      // margin-left: 30px;
      > div:nth-child(2) {
        display: flex;
        margin-top: 20px;
        div {
          span {
            font-size: 30px;
            color: #043d91;
            div {
              font-size: 12px;
            }
          }
        }
        > div:nth-child(2) {
          margin-left: 30px;
        }
      }
    }
  }

  #architecture {
    background-color: #f2f2f2;
    .center {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .box {
        width: 72px;
        text-align: center;
        margin: 10px 0;
        img {
          width: 40px;
        }
        p {
          font-size: 12px;
          color: #333;
        }
      }
    }
  }
  #design {
    > div:nth-child(1) {
      text-align: center;
      margin-top: 40px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
    }
    > div:nth-child(2) {
      text-align: center;
      color: #333333;
    }
    > .center {
      display: flex;
      flex-wrap: wrap;
      .box1 {
        width: 33%;
        background-color: #f2f2f2;
        text-align: center;
        img {
          width: 100%;
          height: 100%;
        }
        div:nth-child(1) {
          font-size: 12px;
          margin-top: 0px;
          // color: #303030;
          line-height: 60px;
        }
        div:nth-child(2) {
          display: none;
        }
      }
    }
  }
  #process {
    > div:nth-child(1) {
      text-align: center;
      margin-top: 20px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
    }
    > div:nth-child(2) {
      text-align: center;
      color: #333333;
    }
    .center {
      .left {
        display: none;
      }

      .right {
        color: #5c5c5c;
        text-align: left;
        height: 270px;
        >.box1{
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 80%;
          }
        }

        #year {
        width: 80%;
        margin: 20px auto 4px;
         
          > span:nth-child(1) {
            font-size: 20px;
            font-weight: 500;
          }
          > span:nth-child(2) {
            font-weight: 500;
          }
        }
        #content {
           width: 80%;
        margin: 0 auto;
          font-weight: 500;
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }

  #location {
    margin-top: 6px;
    .title {
      text-align: center;
      margin-top: 20px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
    }
    .center{
           padding-top: 6px;
    }
    .left {
 
      #countryTitle {
        font-size: 14px;
        margin-bottom: 0px;
        padding-bottom: 6px;
      }
      div:nth-child(3),div:nth-child(2){
        line-height: 14px;
    
      }
      
    }
    .right{
      margin-top: 4px;
    }
    div:nth-child(2) {
      color: #333333;
    }
    > .timeline {
      display: flex;
      flex-direction: column;
      #container {
        display: none;
        // width: 1200px;
        background-color: #d5d5d5;
        position: absolute;
        div {
          width: 43px;
          border: 2px solid #053e91;
          position: relative;
          left: 0;
        }
      }
      #country {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 0px;
        font-size: 12px;
        > .box1 {
          text-align: center;

          // font-size: 22px;
          font-weight: 500;
          color: #333333;
          div {
            margin-top: 0px;
            font-size: 12px;
          }
        }
        > .box1:hover {
          color: #043d91;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
